<template>
  <div v-if="disabled" :style="templateType">
    未找到用户或用户已注销！
  </div>
    <div v-else :style="templateType">
        <!-- 顶部banner -->
        <div class="model_top">
            <img v-if="banner != null"  :src="banner" alt="" class="model_topBanner"/>
            <img v-else  src="../../assets/设计市场/设计师详情banner.png" alt="" class="model_topBanner"/>
            <div class="model_topNums">
                <div class="model_topNums2 flex">
                    <div class="model_topNumsBox">
                        <p>浏览量</p>
                        <p >{{designer.viewNum+designer.accessNum}}</p>
                    </div>
                    <div class="model_topNumsBox">
                        <p>订单量</p>
                        <p>{{designer.totalOrderNum}}</p>
                    </div>
                    <div class="model_topNumsBox">
                        <p>作品量</p>
                        <p>{{designer.productionNum}}</p>
                    </div>
                    <div class="model_topNumsBox">
                        <p>粉丝</p>
                        <p >{{designer.likeNum}}</p>
                    </div>
                </div>
            </div>
            <!-- 设计简介 -->
            <div class="designer">
                <div class="designerBox">
                    <div class="designerImg">
                        <img :src="designer.headImg" alt="" v-if="designer.headImg"/>
                        <img v-if="designer.sex == 'MALE'" src="../../assets/模型库/sexIcon.png"
                             style="width: 45px;height: 45px;position: absolute;right: -4px;bottom: -4px;">
                        <img v-if="designer.sex == 'FEMALE'" src="../../assets/模型库/sexIcon1.png"
                             style="width: 45px;height: 45px;position: absolute;right: -4px;bottom: -4px;">
                        <img v-if="designer.sex == 'SECRET'" src="../../assets/模型库/sexIcon2.png"
                             style="width: 45px;height: 45px;position: absolute;right: -4px;bottom: -4px;">
                        <img src="../../assets/users.png" alt="" v-if="!designer.headImg">
                    </div>
                    <div class="designer_name">
                        <p>
                          <span v-text="designer.nickname">三维教育</span>
                          <img v-for="(item,index) in designerLevelList" src="../../assets/模型库/designIcon.png" :src="item.levelIconUrl" title="" :title="item.name"
                                       style="width: 55px;height: 20px;margin-left: 5px;">
                        </p>
                        <i></i>
                    </div>
                    <p class="designer_city" v-if="designer.province" v-text="designer.province + '|' + designer.city + '|' + designer.district">宁夏|银川|金凤区</p>
                    <p class="designer_from" v-text="designer.introduction">擅长工业产品设计，入行12年，经验丰富，曾在设计大赛中多次获得设计大奖，善于借助线条，经验丰富。</p>
                    <div class="designer_button flex">
                        <button v-if="!like" @click="liked(designer.uuid)">关注</button>
                        <button v-if="like" @click="liked(designer.uuid)">已关注</button>
                        <button @click="startChat(userUuid)">私信</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 设计师模块--内容部分 -->
        <div class="design_content flex">
            <!-- 内容部分的左边 -->
            <div class="design_content_left">
                <div class="left_goodAt">
                    <p class="left_goodAt_title blue">擅长领域</p>
                    <div>
                        <svg :width="width" :height="height" class="left_goodAt_ibox">
                            <a
                                href="javascript:void(0)"
                                v-for="(tag, index) in goodAt"
                                :key="index"
                                class="left_goodAt_label"
                            >
                                <text
                                    :x="tag.x"
                                    :y="tag.y"
                                    :font-size="20 * (600 / (600 - tag.z))"
                                    :fill-opacity="(400 + tag.z) / 600"
                                >
                                    {{ tag.name }}
                                </text>
                            </a>
                        </svg>
                    </div>

                </div>

                <div class="left_recommended">
                    <p class="left_recommended_title blue">同类设计师推荐</p>
                    <div
                        class="left_recommended_box flex"
                        v-for="(items, index) in recommendedList"
                        :key="index" @click="getDesigner(items.uuid)"
                    >
                        <div class="recommended_img">
                            <img v-if="items.image" :src="items.image" alt=""/>
                            <img v-else  src="../../assets/设计市场/头像1.jpeg" alt=""/>
                        </div>
                        <div class="recommended_boxR">
                            <div class="recommended_nameBox">
                                <p class="recommended_name">{{ items.name }}</p>
                                <i></i>
                            </div>
                            <p class="recommended_label">{{ items.city }}|{{ items.work }}</p>

                            <div class="recommended_fans flex">
                                <p>作品 {{ items.num }}</p>
                                <i></i>
                                <p>粉丝 {{ items.fans }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 内容部分的右边 -->
            <div class="design_content_right">
                <div class="right_tabs flex">
                    <p
                        :class="menuName == items.title ? 'tabs_active' : ''"
                        v-for="(items, index) in tabsRight"
                        :key="index"
                        v-show="items.type =='BOTH' || designerType==items.type || designerType=='BOTH'"
                        @click="getDesignerMess(items.title)"
                    >
                        {{ items.title }}
                    </p>
                </div>
                <div v-if="menuName == '我的模型' " >
                    <div class="print_screen">
                      <div class="print_screen_box flex" style="position: relative">
                        <!-- <div class="uploadModelButton">上传模型</div> -->
                        <p class="print_title">分类：</p>
                        <div>
                          <div class="print_screen_boxP">
                            <p
                                v-for="(items, index) in screenList"
                                :key="index"
                                @click="getPrintScreen(index, items.name)"
                                :class="printScreenIndex == index ? 'screen_text' : ''"
                            >
                              {{ items.name }}
                            </p>
                            <!-- <p
                              @click="getPrintScreen(index, items.name)"
                              :class="printScreenIndex == index ? 'screen_text' : ''"
                            >
                              {{ items.name }}
                            </p> -->
                          </div>
                          <div
                              class="flex"
                              style="padding: 15px 15px 5px; background: rgb(241, 245, 254)"
                              v-show="screenList[printScreenIndex].name == '全部'? classShow= false:classShow= true"
                          >
                            <p
                                v-for="(items, index) in screenList2"
                                :key="index"
                                :class="printScreenTwoIndex == index ? 'materDetailsT' : ''"
                                @click="getPrintScreenTwo(index)"
                                style="cursor: pointer"
                            >
                              {{ items.name }}
                            </p>
                          </div>
                        </div>
                      </div>
                        <!-- 筛选 -->
                        <div class="flex print_screen_box print_shai">
                            <p>筛选：</p>
                            <p
                                    :class="printNews2 == items.value ? 'print_newsPs' : 'print_newsP'"
                                    v-for="(items, index) in printNewss2"
                                    :key="items.value"
                                    @click="getPrintNews2(items.value)"
                            >
                                {{ items.name }}
                            </p>
                        </div>
                    </div>

                    <div class="print_news flex">
                        <div class="flex print_news1">
                                <p  style="cursor: pointer"
                                    :class="printNews == items.value ? 'print_sort' : 'print_sort2'"
                                    v-for="(items, index) in printNewss"
                                    :key="index"
                                    @click="getPrintNews(items.value)"
                                >
                                {{ items.title }}
                                    <i class="el-icon-bottom" v-if="items.value=='NEW'&& getPrintNews1==0"></i>
                                    <i class="el-icon-top" v-if="items.value=='NEW'&& getPrintNews1==1"></i>
                                    <i class="el-icon-bottom" v-if="items.value=='HOT'&& getPrintNews6==0"></i>
                                    <i class="el-icon-top" v-if="items.value=='HOT'&& getPrintNews6==1"></i>
                                    <i class="el-icon-bottom" v-if="items.value=='COLLECTION'&& getPrintNews3==0"></i>
                                    <i class="el-icon-top" v-if="items.value=='COLLECTION'&& getPrintNews3==1"></i>
                                    <i class="el-icon-bottom" v-if="items.value=='LIKE'&& getPrintNews4==0"></i>
                                    <i class="el-icon-top" v-if="items.value=='LIKE'&& getPrintNews4==1"></i>
                                    <i class="el-icon-bottom" v-if="items.value=='DOWNLOAD'&& getPrintNews5==0"></i>
                                    <i class="el-icon-top" v-if="items.value=='DOWNLOAD'&& getPrintNews5==1"></i>
                            </p>
                        </div>

                    </div>
                    <div class="right_search flex">
                        <p>{{"共上传"+modelTotal+"组创作"}}</p>
                        <div class="right_searchBox">
                            <input @keyup="modelSearch" v-model="searchModel" type="text" placeholder="输入关键词"/>
                            <i class="iconfont">&#xe6a8;</i>
                        </div>
                    </div>
                    <div v-if="modelList.length==0" style="text-align:center;margin-bottom:20px" >
                        <img src="../../assets/暂无内容.jpg" alt="" style="width:200px">
                    </div>
                    <div class="right_list flex" v-if="modelList.length!=0">
                        <waterfall :col='4' :width="itemWidth" :gutterWidth="gutterWidth" :data="modelList" :loadDistance="100">
                            <div
                                class="right_listbox"
                                v-for="(items, index) in modelList"
                                :key="index" @click="getModelDetalis(index)">
                                <div class="listbox_img">
                                    <el-image  fit="cover" style="cursor: pointer" :src="items.imgUrl" alt=""></el-image>
                                    <el-tag class="mdfree" effect="plain">
                                        {{ items.attributeCn }}
                                    </el-tag>
                                </div>
                                <div class="listbox_center">
                                    <div class="listbox_center_title flex">
                                        <p>{{ items.modelName| ellipsisService}}</p>
                                        <span>{{ items.time }}</span>
                                    </div>
                                    <p class="listbox_center_des">{{ items.typeFirstName }}-{{ items.typeSecondName }}</p>
                                </div>
                                <div class="listbox_bottom flex">
                                    <p class="flex">
                                        <i class="iconfont">&#xe611;</i>{{ items.accessNum }}
                                    </p>
                                    <p class="flex">
                                        <i class="iconfont">&#xe639;</i>{{ items.likeNum }}
                                    </p>
                                    <p class="flex">
                                        <i class="iconfont">&#xe60d;</i>{{ items.commentsNum }}
                                    </p>
                                </div>
                            </div>
                        </waterfall>
                        <div class="right_listbox_o"></div>
                        <div class="right_listbox_o"></div>
                        <div class="right_listbox_o"></div>
                    </div>
                </div>
                <Designs v-if="menuName == '平面设计'"/>
                <DesignIntroduction v-if="menuName == '我的简介'"/>
                <DesignResults v-if="menuName == '成果展示' "/>
                <DesignComments v-if="menuName == '评论列表' " :title="userUuid"/>
                <TransactionRecords ref="transactionRecordRef" v-if="menuName == '成交记录' "/>
            </div>
        </div>

      <!--聊天窗口-->
      <chat-dialog ref="chatDialogRef"></chat-dialog>
    </div>
</template>

<script>
    import DesignResults from "./designResults";
    import Designs from "./designs";
    import DesignIntroduction from "./designIntroduction";
    import DesignComments from "./designComments";
    import TransactionRecords from "../transactionRecords/transactionRecords";
    import {
      designerViewDetail,
      designerList,
      queryModelList,
      queryProductList,
      hasLiked,
      like,
      getRongCloudUser,
      getDesignBanner, getDesignLevel, saveModelCollection, pageSettingInfo, designerListByPage, getDictionaryGroup, getDictionaryItem
    } from "../../utils/interface";
    import { getHumanDate } from "../../utils/date";
    import {mapState, mapMutations} from "vuex";
    import chatDialog from "../chat/chatDialog";
    export default {
        //   设计师模型
        name: "designModel",
        metaInfo () {
            return {
                title: this.metaTitle,
                meta: [{                 // set meta
                    name: "keywords",
                    content: this.metaKeywords,
                },
                    {                 // set meta
                        name: "description",
                        content: this.metaDescription,
                    }
                ],
            }
        },
        components: {
            Designs,
            DesignResults,
            DesignIntroduction,
            DesignComments,
            chatDialog,
            TransactionRecords
        },
        data() {
            return {
                disabled:false,
                getPrintNews1:0,
                getPrintNews6:0,
                getPrintNews3:0,
                getPrintNews4:0,
                getPrintNews5:0,
                designerType: '',
                banner: null,
                userUuid: '',
                like: false,
                width: 274,
                //svg宽度
                height: 274,
                //svg高度
                RADIUS: 200,
                //球的半径
                speedX: Math.PI / 360,
                //球一帧绕x轴旋转的角度
                speedY: Math.PI / 360,
                //球-帧绕y轴旋转的角，度
                tags: [],
                printScreenIndex: "0",
                printScreenTwoIndex: "0",
                printNews: "NEW",
                printNews2: "",
                menuName:'我的模型',
                goodAt: [
                ],
                printNewss2: [
                    {
                        value : "",
                        name: "全部",
                    },
                    {
                        value : "FREE",
                        name: "免费模型",
                    },
                    {
                        value : "PAY",
                        name: "收费模型",
                    },
                    {
                        value : "BROWSE",
                        name: "仅预览",
                    },
                ],
                printNewss: [
                    {
                        value: "NEW",
                        title: "最新",
                    },
                    {
                        value: "HOT",
                        title: "最热",
                    },
                    {
                        value: "COLLECTION",
                        title: "收藏",
                    },
                    {
                        value: "LIKE",
                        title: "点赞",
                    },
                    {
                        value: "DOWNLOAD",
                        title: "下载",
                    },
                ],
                screenList: [
                    {
                        name: "全部",
                        screenTwo: [
                            {
                                names: "汽车配件",
                            },
                            {
                                names: "机床配件",
                            },
                            {
                                names: "生物医疗",
                            },
                            {
                                names: "航空航天",
                            },
                            {
                                names: "其它",
                            },
                        ],
                    },
                    {
                        name: "工业模型",
                        screenTwo: [
                            {
                                names: "汽车配件",
                            },
                            {
                                names: "机床配件",
                            },
                            {
                                names: "生物医疗",
                            },
                            {
                                names: "航空航天",
                            },
                            {
                                names: "其它",
                            },
                        ],
                    },
                    {
                        name: "建筑模型",
                        screenTwo: [
                            {
                                names: "标志建筑",
                            },
                            {
                                names: "普通建筑",
                            },
                            {
                                names: "城堡寺庙",
                            },
                            {
                                names: "其它",
                            },
                        ],
                    },
                    {
                        name: "电子产品",
                        screenTwo: [
                            {
                                names: "家电模型",
                            },
                            {
                                names: "计算机",
                            },
                            {
                                names: "摄像机",
                            },
                            {
                                names: "数码配件",
                            },
                            {
                                names: "手机壳",
                            },
                            {
                                names: "手机/PAD支架",
                            },
                            {
                                names: "小玩意",
                            },
                        ],
                    },
                    {
                        name: "人物角色",
                        screenTwo: [
                            {
                                names: "动漫手办",
                            },
                            {
                                names: "写实人物",
                            },
                            {
                                names: "民族宗教",
                            },
                            {
                                names: "机器人",
                            },
                            {
                                names: "游戏影视",
                            },
                        ],
                    },
                    {
                        name: "教育学习",
                        screenTwo: [
                            {
                                names: "物理化学",
                            },
                            {
                                names: "生物医学",
                            },
                            {
                                names: "字母符号",
                            },
                            {
                                names: "天文地理",
                            },
                            {
                                names: "数学",
                            },
                            {
                                names: "美术",
                            },
                            {
                                names: "体育",
                            },
                            {
                                names: "音乐",
                            },
                        ],
                    },
                    {
                        name: "工具用具",
                        screenTwo: [
                            {
                                names: "支架底座",
                            },
                            {
                                names: "连接结构",
                            },
                            {
                                names: "办公工具",
                            },
                            {
                                names: "齿轮传动",
                            },
                            {
                                names: "夹持结构",
                            },
                            {
                                names: "机械工具",
                            },
                            {
                                names: "手工工具",
                            },
                            {
                                names: "手柄按钮",
                            },
                        ],
                    },
                    {
                        name: "交通玩具",
                        screenTwo: [
                            {
                                names: "轮船",
                            },
                            {
                                names: "汽车",
                            },
                            {
                                names: "飞行器",
                            },
                            {
                                names: "武器",
                            },
                            {
                                names: "玩偶",
                            },
                            {
                                names: "益智玩具",
                            },
                            {
                                names: "其它",
                            },
                        ],
                    },
                    {
                        name: "动物植物",
                        screenTwo: [
                            {
                                names: "动物模型",
                            },
                            {
                                names: "植物模型",
                            },
                            {
                                names: "奇异生物",
                            },
                        ],
                    },
                    {
                        name: "时尚饰品",
                        screenTwo: [
                            {
                                names: "戒指",
                            },
                            {
                                names: "项链",
                            },
                            {
                                names: "手饰",
                            },
                            {
                                names: "头饰",
                            },
                            {
                                names: "服饰",
                            },
                        ],
                    },
                    {
                        name: "家居用品",
                        screenTwo: [
                            {
                                names: "客厅物品",
                            },
                            {
                                names: "浴室物品",
                            },
                            {
                                names: "厨房物品",
                            },
                            {
                                names: "家具",
                            },
                            {
                                names: "挂钩",
                            },
                            {
                                names: "装饰品",
                            },
                            {
                                names: "容器",
                            },
                        ],
                    },
                    {
                        name: "艺术结构",
                        screenTwo: [
                            {
                                names: "钱币徽章",
                            },
                            {
                                names: "互动艺术",
                            },
                            {
                                names: "数学艺术",
                            },
                            {
                                names: "头logo饰",
                            },
                            {
                                names: "雕塑文物",
                            },
                            {
                                names: "2D艺术",
                            },
                        ],
                    },
                    {
                        name: "其它模型",
                        screenTwo: [
                            {
                                names: "奖杯模型",
                            },
                            {
                                names: "沙盘模型",
                            },
                            {
                                names: "食品模型",
                            },
                        ],
                    },
                ],
                screenList2: [
                  {
                    uuid: "",
                    name: "全部",
                  },
                ],
                recommendedList: [
                ],
                tabsRight: [],
                tabsRightIndex: "0",

                sortBox2: [
                    {
                        name: "全部",
                    },
                    {
                        name: "免费模型",
                    },
                    {
                        name: "收费模型",
                    },
                    {
                        name: "仅预览",
                    },
                ],
                sortboxIndex: "0",
                sortboxTwoIndex: '0',
                sortbox2Index: "0",
                messageList: [
                    {
                        title: "艺术摆件",
                        time: "2小时前",
                        message: "家居用品/装饰品-付费模型",
                        see: "49",
                        good: "34",
                        say: "23",
                        image: require("../../assets/模型库/埃菲尔铁塔.png")
                    },
                    {
                        title: "齿轮模型",
                        time: "2小时前",
                        message: "工业模型/机床配件-付费模型",
                        see: "45",
                        good: "34",
                        say: "24",
                        image: require("../../assets/设计市场/齿轮模型.jpg")
                    },
                    {
                        title: "城堡模型",
                        time: "2小时前",
                        message: "建筑模型/普通建筑-免费模型",
                        see: "34",
                        good: "23",
                        say: "44",
                        image: require("../../assets/模型库/手办.png")
                    },
                    {
                        title: "大白模型",
                        time: "2小时前",
                        message: "人物角色/动漫手办-免费模型",
                        see: "33",
                        good: "32",
                        say: "44",
                        image: require("../../assets/设计市场/大白模型.jpg")
                    },
                    {
                        title: "几何模型",
                        time: "2小时前",
                        message: "工具用具/办公工具-付费模型",
                        see: "45",
                        good: "50",
                        say: "33",
                        image: require("../../assets/模型库/玩具.png")
                    },
                    {
                        title: "哆啦A梦模型",
                        time: "2小时前",
                        message: "人物角色/动漫手办-免费模型",
                        see: "11",
                        good: "32",
                        say: "34",
                        image: require("../../assets/设计市场/哆啦A梦模型.jpg")
                    },
                    {
                        title: "眼镜模型",
                        time: "2小时前",
                        message: "家居用品/容器-免费模型",
                        see: "35",
                        good: "34",
                        say: "22",
                        image: require("../../assets/设计市场/眼镜模型.jpg")
                    },
                    {
                        title: "汽车模型",
                        time: "2小时前",
                        message: "交通玩具/汽车-付费模型",
                        see: "35",
                        good: "25",
                        say: "15",
                        image: require("../../assets/模型库/笔筒.png")
                    },
                    {
                        title: "房屋模型",
                        time: "2小时前",
                        message: "建筑模型/普通建筑-免费模型",
                        see: "25",
                        good: "23",
                        say: "1",
                        image: require("../../assets/设计市场/房屋模型.jpg")
                    },
                    {
                        title: "水龙头模型",
                        time: "2小时前",
                        message: "工业模型/机床配件-付费模型",
                        see: "5",
                        good: "34",
                        say: "21",
                        image: require("../../assets/设计市场/水龙头模型.jpg")
                    },
                    {
                        title: "三维山体模型",
                        time: "2小时前",
                        message: "教育学习/天文地理-付费模型",
                        see: "23",
                        good: "3",
                        say: "44",
                        image: require("../../assets/模型库/米老鼠.png")
                    },
                    {
                        title: "飞机模型",
                        time: "2小时前",
                        message: "儿童玩具/益智玩具-付费模型",
                        see: "23",
                        good: "25",
                        say: "35",
                        image: require("../../assets/设计市场/飞机模型.jpg")
                    },
                ],
                classShow: false,
                designer: {province:"",city:"",district:""},
                modelList : [],
                modelTotal : 0,
                searchModel :"",
                timeOut :null,
                productList : [],
                productTotal : 0,
                productTimeOut:null,
                designerLevelList : [],
                order:"DESC",
                templateType:"background: #F9F9F9;",
                metaTitle:'',
                metaKeywords:'',
                metaDescription:'',
            };
        },
        computed: {
            ...mapState({
                isTokenDoor: "isTokenDoor",
                isLogin: "isLogin",
            }),
            CX() {
                // 球心x坐标
                return this.width / 2;
            },
            CY() {
                // 球心y坐标
                return this.height / 2;
            },
            itemWidth() {
                return 208
                //rem布局 计算列宽度
                //可以根据自己的rem设置修改这里的 334 值
            },
            gutterWidth() {
                return 20

                //rem布局 计算x轴方向margin(y轴方向的margin自定义在css中即可)

                //可以根据自己的rem设置修改这里的 36 值

            },
        },
        created() {
            this.getDetailInfo();
        },
        mounted() {
            //使球开始旋转
            setInterval(() => {
                this.rotateX(this.speedX);
                this.rotateY(this.speedY);
            }, 50);
        },
         filters: {
            ellipsisService(value) {
                if (!value) return '';
                if (value.length > 8) {
                    return value.slice(0, 8) + '...'
                }
                return value;
            }
        },
        methods: {
            ...mapMutations(["isLoginVuex"]),
            getGroup() {
              getDictionaryGroup({ parentCode: "MODEL_CATEGORIES" }).then((res) => {
                res.unshift({
                  uuid: "",
                  name: "全部",
                });
                this.screenList = res;
              });
            },
            getDetailInfo(){
                designerViewDetail(this.$route.params.uuid).then((res) => {
                    // console.log(JSON.stringify(res));
                    if(res != null){
                        if(res.survival!="ENABLE"){
                          this.disabled = true;
                          return;
                        }
                        this.hasLiked();
                        this.getDesignerList();
                        this.getGroup();
                        this.metaTitle = res.nickname+" - 设计市场-增材云";
                        this.metaKeywords = res.metaKeywords;
                        this.metaDescription = res.metaDescription;

                        this.designerType = res.type;
                        this.designer = res;
                        this.designer.headImg = res.iconUrl == (null || '') ? require('../../assets/设计市场/头像1.jpeg') : res.iconUrl;
                        this.getDesignBanner();
                        this.userUuid = res.userId;
                        let goodAtList = [];
                        if(res.designerGoodatList != null && res.designerGoodatList.length > 0){
                            res.designerGoodatList.forEach((item, index) => {
                                goodAtList.push({name : item.goodatName});
                            });
                            this.goodAt = goodAtList;
                            //初始化标签位置
                            //让vue替我们完成视图更新
                            let tags = [];
                            let tagsName = [];
                            for (let i = 0; i < this.goodAt.length; i++) {
                                let tag = {};
                                let k = -1 + (2 * (i + 1) - 1) / this.goodAt.length;
                                let a = Math.acos(k);
                                let b = a * Math.sqrt(this.goodAt.length * Math.PI);
                                this.goodAt.forEach((items, index) => {
                                    tagsName.push(items.name);
                                });
                                tag.name = tagsName[i];
                                tag.x = this.CX + this.RADIUS * Math.sin(a) * Math.cos(b);
                                tag.y = this.CY + this.RADIUS * Math.sin(a) * Math.sin(b);
                                tag.z = this.RADIUS * Math.cos(a);
                                tags.push(tag);
                            }
                            this.goodAt = tags;
                        }

                        this.tabsRight = [];
                        if(res.type == 'BOTH'){
                            this.tabsRight.push({title: '我的模型',type:'MODEL'});
                            this.tabsRight.push({title: '我的简介',type:'BOTH'});
                            this.tabsRight.push({title: '平面设计',type:'GRAPHIC'});
                            this.tabsRight.push({title: '成果展示',type:'MODEL'});
                            this.tabsRight.push({title: '评论列表',type:'BOTH'});
                            this.tabsRight.push({title: '成交记录',type:'BOTH'});
                            this.getModelList();
                        }else if(res.type == 'MODEL'){
                            this.tabsRight.push({title: '我的模型',type:'MODEL'});
                            this.tabsRight.push({title: '我的简介',type:'BOTH'});
                            this.tabsRight.push({title: '成果展示',type:'MODEL'});
                            this.tabsRight.push({title: '评论列表',type:'BOTH'});
                            this.tabsRight.push({title: '成交记录',type:'BOTH'});
                            this.getModelList();
                        }else if(res.type == 'GRAPHIC'){
                            this.menuName='平面设计';
                            this.tabsRight.push({title: '平面设计',type:'GRAPHIC'});
                            this.tabsRight.push({title: '我的简介',type:'BOTH'});
                            this.tabsRight.push({title: '评论列表',type:'BOTH'});
                            this.tabsRight.push({title: '成交记录',type:'BOTH'});
                        }
                        this.getDesignerLevel();
                        this.getDesignerList();
                    }
                    pageSettingInfo(res.userId).then((res) =>{
                        if(res.data !=null){
                            if(res.data.templateNo=="two"){
                                this.templateType=`background: url(${require('../../assets/image/base_two.png')})`;
                            }
                            if(res.data.menuSettingList !=null && res.data.menuSettingList.length>0){
                                this.tabsRight = [];
                                res.data.menuSettingList.forEach((items, index) => {
                                    if(index==0){
                                        this.menuName = items.menuName;
                                    }
                                    this.tabsRight.push({title: items.menuName,type:items.type,indexSort:index});
                                });
                                console.log("------------2-------------")
                                console.log(this.tabsRight)
                            }
                        }
                    })
                });

            },
            getDesignerLevel(){
                getDesignLevel({
                    designerUuid : this.designer.uuid
                }).then((res) => {
                    this.designerLevelList = res;
                    console.log(this.designerLevelList)
                });
            },
            getDesignerList(){
                let param ={};
                if(this.isLogin){
                    param = {
                        status:  "PASS",
                        isLogin: 1,
                    }
                }else{
                    param = {
                        status:  "PASS",
                        isLogin: 0,
                    }
                }
                designerList(param).then((res) => {
                    if(res != null && res.length > 0){
                        // console.log(res);
                        res.forEach((item, index) => {
                            let designer = {};
                            if(item.uuid != this.$route.params.uuid && this.recommendedList.length <= 4 && this.designer.type == item.type){
                                designer.uuid = item.uuid;
                                designer.name = item.nickname;
                                designer.city = item.city;
                                designer.work = item.typeCn;
                                designer.num = item.productionNum;
                                designer.fans = item.likeNum;
                                designer.image = item.iconUrl;

                                this.recommendedList.push(designer);
                            }
                        });
                    }
                });
            },
            rotateX(angleX) {
                var cos = Math.cos(angleX);
                var sin = Math.sin(angleX);
                for (let tag of this.goodAt) {
                    var y1 = (tag.y - this.CY) * cos - tag.z * sin + this.CY;
                    var z1 = tag.z * cos + (tag.y - this.CY) * sin;
                    tag.y = y1;
                    tag.z = z1;
                }
            },

            rotateY(angleY) {
                var cos = Math.cos(angleY);
                var sin = Math.sin(angleY);
                for (let tag of this.goodAt) {
                    var x1 = (tag.x - this.CX) * cos - tag.z * sin + this.CX;
                    var z1 = tag.z * cos + (tag.x - this.CX) * sin;
                    tag.x = x1;
                    tag.z = z1;
                }
            },
            getPrintScreen(i) {
              if (this.printScreenIndex == i) {
                this.classShow = !this.classShow;
              } else {
                // if (i === 0) {
                //   console.log('111', );
                //   this.screenList2 = [];
                // } else {
                getDictionaryItem({ groupCode: this.screenList[i].code }).then(
                    (itemList) => {
                      itemList.unshift({
                        uuid: "",
                        name: "全部",
                      });
                      this.screenList2 = itemList;
                      this.getPrintScreenTwo(0)
                    }
                );
                // }
                this.classShow = true;
              }
              this.printScreenIndex = i;
              this.current=1;
              this.getModelList();
            },
            getPrintScreenTwo(i) {
                this.current=1;
                this.printScreenTwoIndex = i;
                this.getModelList();
            },
            getPrintNews(i) {
                // console.log(i)
                this.printNews = i;

                if(this.printNews=="NEW"&&this.getPrintNews1==0){
                    this.order = 'DESC';
                    this.getPrintNews1=1
                }else if(this.printNews=="NEW"&&this.getPrintNews1==1){
                    this.order = 'ASC';
                    this.getPrintNews1=0
                }else if(this.printNews=="HOT"&&this.getPrintNews6==0){
                    this.order = 'DESC';
                    this.getPrintNews6=1
                }
                else if(this.printNews=="HOT"&&this.getPrintNews6==1){
                    this.order = 'ASC';
                    this.getPrintNews6=0
                }else if(this.printNews=="COLLECTION"&&this.getPrintNews3==0){
                    this.order = 'DESC';
                    this.getPrintNews3=1
                }
                else if(this.printNews=="COLLECTION"&&this.getPrintNews3==1){
                    this.order = 'ASC';
                    this.getPrintNews3=0
                }else if(this.printNews=="LIKE"&&this.getPrintNews4==0){
                    this.order = 'DESC';
                    this.getPrintNews4=1
                }
                else if(this.printNews=="LIKE"&&this.getPrintNews4==1){
                    this.order = 'ASC';
                    this.getPrintNews4=0
                }else if(this.printNews=="DOWNLOAD"&&this.getPrintNews5==0){
                    this.order = 'DESC';
                    this.getPrintNews5=1
                }
                else if(this.printNews=="DOWNLOAD"&&this.getPrintNews5==1){
                    this.order = 'ASC';
                    this.getPrintNews5=0
                }

                this.getModelList();
            },
            getPrintNews2(i) {
                this.printNews2 = i;
                this.getModelList();
            },
            getDesignerMess(index) {
                this.menuName = index;
                if(index == '我的模型') this.getModelList();
                // 四个参数代表 goodsUuid,orderType,enterPriseUuid,detailUuid
                // 不需要的就不用填
                this.$nextTick(function () {
                    if(this.menuName == '成交记录' ) this.$refs.transactionRecordRef.init("", "", this.designer.userId, "","");
                });


            },
            getSortBox(index) {
                if (this.sortboxIndex == index) {
                    this.classShow = !this.classShow;
                } else {
                    this.classShow = true;
                }
                this.sortboxIndex = index;
                this.addLabelList = this.addLabelList[index].screenTwo;
            },
            getSortboxTwo(i) {
                this.sortboxTwoIndex = i;
            },
            getSortBox2(index) {
                this.sortbox2Index = index;
            },
            modelSearch(){
                if(this.timeOut == null){
                    this.timeOut = setTimeout(this.getModelList,1000);
                }else{
                    clearTimeout(this.timeOut);
                    this.timeOut = setTimeout(this.getModelList,1000);
                }
            },
            getModelList(){
                let param ={};
                if(this.isLogin){
                    param = {
                        userUuid : this.designer.userId,
                        orderBy :this.printNews,
                        order: this.order,
                        search : this.searchModel,
                        status: "RELEASED",
                        current : 1,
                        pageSize :10000,
                        typeFirstUuid:
                            this.printScreenIndex == 0
                                ? ""
                                : this.screenList[this.printScreenIndex].uuid,
                        typeSecondUuid:
                            this.printScreenTwoIndex == 0
                                ? ""
                                : this.screenList2[this.printScreenTwoIndex].uuid,
                        attribute: this.printNews2,
                        isLogin: 1,
                    }
                }else{
                    param = {
                        userUuid : this.designer.userId,
                        orderBy :this.printNews,
                        order: this.order,
                        search : this.searchModel,
                        status: "RELEASED",
                        current : 1,
                        pageSize :10000,
                        typeFirstUuid:
                            this.printScreenIndex == 0
                                ? ""
                                : this.screenList[this.printScreenIndex].uuid,
                        typeSecondUuid:
                            this.printScreenTwoIndex == 0
                                ? ""
                                : this.screenList2[this.printScreenTwoIndex].uuid,
                        attribute: this.printNews2,
                        isLogin: 0,
                    }
                }
                queryModelList(param).then((res) => {
                    this.modelTotal = res.total ;
                    res.list.map(item =>{
                        item.time = getHumanDate(new Date(item.createDate).getTime(),true);
                    })
                    this.modelList = res.list;
                    console.log(this.modelList)
                    if(this.timeOut!=null){
                        clearTimeout(this.timeOut);
                        this.timeOut =null;
                    }
                });
            },
            getModelDetalis(i){
                let routeData = this.$router.resolve({
                    name: "modelDetails",
                    query: {
                        uuid: this.modelList[i].uuid,
                    },
                });
                console.log(routeData)
                window.open(routeData.href, "_blank");
            },
            getDesigner(uuid) {
                console.log(uuid);
                let routeData = this.$router.resolve({
                    name: "designModel",  params: {uuid: uuid}
                });
                window.open(routeData.href, "_blank");
            },
            hasLiked(){
                hasLiked(this.$route.params.uuid).then((res) => {
                    this.like = res;
                })
            },
            liked(uuid) {
                if (this.isLogin) {
                    if(this.$store.state.isUsermessage.uuid == this.designer.userId){
                        this.$message({
                            type: "success",
                            message: "不能关注自己！",
                        });
                        return ;
                    }
                let params = {
                    likeType: 'DESIGNER',
                    serviceType: 'LIKE',
                    designerUuid: uuid,
                };
                like(params).then((res) => {
                    if(res && res.success){
                        this.getDetailInfo();
                        this.hasLiked();
                        this.$message({
                            type: "success",
                            message: res.message,
                        });
                    }
                });
            } else {
                this.$message({
                    type: "success",
                    message: "您需要先登录哦！",
                });
    this.$router.push('/login')
    }
            },

          startChat(targetUserId) {
            if (this.isLogin) {
              let user = this.$store.state.isUsermessage;
              getRongCloudUser(targetUserId).then(res=> {
                this.$refs.chatDialogRef.init(user.uuid,user.name,user.headUrl,res.uuid,res.name,res.headUrl);
              });
            } else {
              this.$message({
                type: "success",
                message: "您需要先登录哦！",
              });
              this.$router.push('/login')
            }
          },
            getDesignBanner(){
                getDesignBanner({userId:this.designer.userId,bannerType:'DESIGNER'}).then((response) => {
                    if(response && response.length > 0){
                            this.banner = response[0].bannerPath;
                            console.log(this.banner);
                    }
                });
            }
        },
    };
</script>

<style scoped lang="less">
    .blue {
        color: #1181ff;
    }
    .print_sort {
        background: #1f7de9;
        color: #fff;

    }
    .print_sort2 {
        background: #fff;
        color: #1f7de9;
    }
    .print_screen {
        background: #F9F9F9;
        .print_screen_box {
            background: #fff;
            margin: 0 auto;
            // flex-wrap: wrap;
            padding: 20px 20px 10px 20px;
            box-sizing: border-box;
            .print_title {
                flex-shrink: 0;
            }
            .print_screen_boxP {
                display: flex;
                flex-wrap: wrap;
                .screen_text {
                    color: #157efb;
                    cursor: pointer;
                    background: #157efb;
                    border-radius: 5px;
                    margin-bottom: 10px;
                    color: #fff;
                    padding: 3px 15px;
                    font-size: 14px;
                }
                p {
                    cursor: pointer;
                }
            }
            .screen_text {
                color: #157efb;
                cursor: pointer;

                background: #157efb;
                border-radius: 5px;
                margin-bottom: 10px;
                color: #fff;
                padding: 3px 15px;
                font-size: 14px;
            }
            p {
                margin-bottom: 10px;
                margin-right: 0px;
                padding: 3px 14px;
                font-size: 14px;
            }
            .materDetailsT {
                // background: #157efb;
                color: #157efb;
                border-radius: 5px;
                padding: 3px 15px;
                margin-bottom: 10px;
            }
        }
        // .print_screen_box:nth-last-child(1) {
        //     border-top: 1px solid #efefef;
        // }
    }

    .print_news {
        margin: 0 auto;
        background-color: #f7f7f7;
        justify-content: space-between;
        height: 50px;
        p {
            font-size: 14px;
            margin-right: 10px;
            border-radius: 3px;
            padding: 3px 9px;
            height: 30px;
            line-height: 25px;
            box-sizing: border-box;
        }

        .print_news1 {
            margin-top: -7px;
            padding: 20px 0;
            flex-shrink: 0;
        }
    }
    .print_shai {
        font-size: 14px;

        p {
            background: #fff;
            padding: 3px 15px;
        }
        .print_newsP {
            margin-right: 30px;
            cursor: pointer;
            background: #fff;
            border-radius: 3px;
            padding: 3px 15px;
        }

        .print_newsPs {
            color: #fff;
            background: #157efb;
            border-radius: 5px;
            padding: 3px 15px;
        }
    }
    .print_input {
        width: 1200px;
        text-align: right;
        position: relative;
        input {
            background: #e4e4e4;
            border: none;
            border-radius: 22px;
            width: 222px;
            height: 30px;
            padding-left: 10px;
        }
        input::-webkit-input-placeholder {
            color: rgb(191, 191, 191);
        }
        i {
            position: absolute;
            top: 25%;
            // transform: translate(0, -50%);
            color: rgb(191, 191, 191);
            right: 10px;
        }
    }
    /* 顶部banner */
    .model_top {
        position: relative;
        .model_topBanner {
            border: 0;
            width: 100%;
            height: 300px;
            background: #efefef;
            display: block;
        }

        .model_topNums {
            position: absolute;
            background: rgba(255, 255, 255, 0.557);
            width: 100%;
            // height: 70px;
            top: 225px;

            .model_topNums2 {
                justify-content: center;
                text-align: center;
                width: 1200px;
                margin: 15px auto;

                .model_topNumsBox {
                    flex: 1;
                }
            }
        }
    }

    /* 设计简介 */
    .designer {
        position: relative;
        text-align: center;
        width: 100%;
        // background: #fff;
        .designerBox{
            width: 500px;
            margin: 0 auto;
            position: relative;
            padding: 85px 0 20px;
        }
        .designerImg {
            width: 130px;
            height: 130px;
            background: #efefef;
            border-radius: 50%;
            position: absolute;
            top: -72px;
            left: 50%;
            margin-left: -65px;
            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }

        .designer_name {
            font-size: 18px;
            margin-bottom: 12px;
            p {
              display: flex;
              align-items: center;
              justify-content: center;
            }
        }

        .designer_city {
            font-size: 13px;
            color: #777;
            margin-bottom: 23px;
        }

        .designer_from {
            font-size: 15px;
            color: #777;
            margin-bottom: 25px;
        }

        .designer_button {
            justify-content: center;

            button {
                cursor: pointer;
                border: 1px solid #1181ff;
                color: #1181ff;
                background: #fff;
                border-radius: 5px;
                font-size: 14px;
                justify-content: space-around;
                width: 90px;
                height: 28px;
            }

            button:nth-child(1) {
                margin-right: 30px;
            }
        }
    }
    .mdfree {
        position: absolute;
        top: 10px;
        left: 10px;
        opacity: 0.6;
        border: none;
        line-height: 20px;
        height: 20px;
        width: 40px;
        text-align: center;
        padding: 0;
        color: #157efb;
    }
    /* 内容部分 */

    .design_content {
        width: 1200px;
        margin: 0 auto;
        padding-bottom: 40px;
        /* 内容部分的左边 */
        padding-top: 20px;
        .design_content_left {
            width: 274px;
            margin-right: 30px;
            flex-shrink: 0;

            .left_goodAt {
                width: 100%;
                border: 1px solid #efefef;
                border-radius: 10px;
                margin-bottom: 34px;
                background: #fff;
                .left_goodAt_title {
                    background: #f3f3f3;
                    font-size: 16px;
                    padding-left: 20px;
                    height: 45px;
                    line-height: 45px;
                    border-radius: 10px 10px 0 0;
                }

                .left_goodAt_ibox {
                    width: 100%;
                    // margin: 10px;
                    margin-bottom: 0;
                    flex-wrap: wrap;
                    justify-content: space-between;

                    .left_goodAt_label {
                        cursor: pointer;
                        border-radius: 10px;
                        background: #f3f8ff;
                        color: #777;
                        font-size: 14px;
                        padding: 10px 15px;
                        margin-bottom: 15px;
                    }
                }
            }

            .left_recommended {
                width: 100%;
                border: 1px solid #efefef;
                border-radius: 10px;
                background: #fff;
                .left_recommended_title {
                    background: #f3f3f3;
                    font-size: 16px;
                    padding-left: 20px;
                    height: 45px;
                    line-height: 45px;
                    border-radius: 10px 10px 0 0;
                }

                .left_recommended_box {
                    cursor: pointer;
                    align-items: center;
                    border-bottom: 1px solid #efefef;
                    padding: 18px;

                    .recommended_img {
                        width: 66px;
                        height: 66px;
                        background: #efefef;

                        img {
                            width: 100%;
                            height: 100%;
                            border-radius: 50%;
                        }
                    }

                    .recommended_boxR {
                        margin-left: 18px;

                        .recommended_nameBox {
                            color: #5a5a5a;
                        }

                        .recommended_label {
                            font-size: 11px;
                            color: rgb(172, 172, 172);
                            margin-bottom: 8px;
                        }

                        .recommended_fans {
                            font-size: 13px;
                            align-items: center;
                            color: #5a5a5a;
                            position: absolute;

                            i {
                                width: 1px;
                                height: 10px;
                                background: #484848;
                                margin: 0 13px;
                            }
                        }

                        .recommended_coop {
                            font-size: 11px;
                            color: rgb(172, 172, 172);
                        }
                    }
                }
            }
        }

        /* 内容部分的右边 */

        .design_content_right {
            color: #525252;
            width: 75%;

            .right_tabs {
                justify-content: space-between;
                font-size: 16px;
                border-bottom: 1px solid #efefef;
                padding-top: 13px;

                .tabs_active {
                    color: #1181ff;
                    border-bottom: 2px solid #1181ff;
                    padding-bottom: 13px;
                }

                p {
                    cursor: pointer;
                }
            }

            .right_addLabel {
                margin: 10px 0 0 100px;
                padding: 15px 10px 0;
                flex-wrap: wrap;
                background: rgb(241, 245, 254);
                border-radius: 2px;

                p {
                    cursor: pointer;
                    margin-right: 30px;
                    margin-bottom: 15px;
                    font-size: 14px;
                }
            }

            .right_sort {
                font-size: 14px;

                .right_sortbox {
                    // height: 32px;
                    // line-height: 32px;
                    padding: 20px 20px 10px;
                    .right_sortboxLeft {
                        padding: 3px 15px;
                        margin-right: 30px
                    }

                    &:nth-of-type(1) {
                        border-bottom: 1px solid #efefef;
                    }

                    p {
                        cursor: pointer;
                        margin-right: 40px;
                        padding: 3px 6px;
                    }

                    .p_active {
                        color: #fff;
                        background: #157efb;
                        border-radius: 5px;
                    }
                    p.materDetailsT{
                        color: #157efb;
                    }

                    P:nth-child(1) {
                        text-align: center;
                    }
                }
            }

            .right_search {
                justify-content: space-between;
                align-items: center;
                margin: 13px 0 20px;

                p {
                    font-size: 14px;
                }

                .right_searchBox {
                    height: 35px;
                    width: 220px;
                    position: relative;

                    input {
                        height: 100%;
                        width: 100%;
                        border: none;
                        background: #f6f6f6;
                        border-radius: 20px;
                        padding-left: 16px;
                        box-sizing: border-box;
                    }

                    i {
                        position: absolute;
                        top: 50%;
                        right: 16px;
                        transform: translate(0, -50%);
                    }
                }
            }

            .right_list {
                justify-content: space-between;
                flex-wrap: wrap;
				/deep/ .vue-waterfall {
					 overflow-y: unset;
				  overflow-x: unset;
				}
                .right_listbox_o {
                    width: 208px;
                    height: 0;
                }

                .right_listbox {
                    cursor: pointer;
                    position: relative;
                    width: 208px;
                    border: 1px solid #efefef;
                    border-radius: 8px;
                    margin-bottom: 26px;
                    background: #fff;
                    .listbox_img {
                        width: 100%;
                        /*height: 130px;*/
                        /*background: #efefef;*/
                        border-radius: 8px;

                        img {
                            width: 100%;
                            height: 100%;
                            border-radius: 8px 8px 0 0;
                        }
                    }

                    .listbox_center {
                        padding: 18px 8px 13px;
                        border-bottom: 1px solid #efefef;

                        .listbox_center_title {
                            justify-content: space-between;
                            align-items: center;

                            span {
                                font-size: 12px;
                                color: rgb(184, 184, 184);
                            }
                        }

                        .listbox_center_des {
                            font-size: 14px;
                            color: #d2d2d2;
                            margin-top: 13px;
                        }
                    }

                    .listbox_bottom {
                        padding: 10px 10px 15px;
                        font-size: 13px;
                        color: #ababab;
                        justify-content: space-between;
                        align-items: center;

                        i {
                            margin-right: 2px;
                        }

                        p {
                            align-items: center;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/design/designModel.vue